export default __webpack_public_path__ + "static/media/bg_testimonial_right.8a13d989.svg";